module.exports = __webpack_public_path__ + "static/media/ic_why_loan2.bbf5fef0.svg";